import { useContext } from 'react';

import { TaggingContext } from '@/context/tagging';

export default function useTagging() {
  const context = useContext(TaggingContext);

  if (!context) {
    throw new Error('useTagging must be called from within TaggingProvider.');
  }

  return context;
}
